import { render, staticRenderFns } from "./addHonors.vue?vue&type=template&id=a8ae6256&scoped=true"
import script from "./addHonors.vue?vue&type=script&lang=js"
export * from "./addHonors.vue?vue&type=script&lang=js"
import style0 from "./addHonors.vue?vue&type=style&index=0&id=a8ae6256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ae6256",
  null
  
)

export default component.exports